import React from 'react';
import { Building, Plug2, Plus } from 'lucide-react';
import { Button } from '../../components/Button';
import Loading from '../../components/Loading';

export const WorkflowHeader = ({
    activeTab,
    setActiveTab,
    selectedClient,
    setSelectedClient,
    clients,
    workflows,
    allTasks,
    workflowTemplates,
    loading,
    setShowCreateWorkflow,
    setShowCreateTask
}) => {
    const allTasksWorkflow = workflows.flatMap(wf =>
        (wf.tasks || []).map(task => ({
            ...task,
            workflowName: wf.name || "Untitled Workflow",
        }))
    );
    
     if (loading) {
        return (
            
                <Loading />
        );
    }
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2">
            <div className="flex items-center justify-between mb-2">
                <h1 className="text-2xl font-bold text-gray-900">Workflow Management</h1>
                {/* <div className="flex space-x-3">
                    <button
                        onClick={() => setShowCreateWorkflow(true)}
                        className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary flex flex-row items-center gap-2"
                    >
                        <Plus size={18}/> Workflow
                    </button>
                    <button
                        onClick={() => setShowCreateTask(true)}
                        className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary flex flex-row items-center gap-2"
                    >
                        <Plus size={18}/> Task
                    </button>
                </div> */}
            </div>

            {/* Client Filter */}
            {/* <div className="flex items-center space-x-4 mb-2">
                <div className="relative">
                    <Building className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                    <select
                        value={selectedClient}
                        onChange={(e) => setSelectedClient(e.target.value)}
                        className="pl-10 pr-4 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                        <option value="">All Clients</option>
                        {clients.map(client => (
                            <option key={client.id} value={client.id}>{client.name}</option>
                        ))}
                    </select>
                </div>
                <div className="text-sm text-gray-600">
                    {selectedClient ? `Showing data for ${clients.find(c => c.id === selectedClient)?.name}` : 'Showing all clients'}
                </div>
            </div> */}

            {/* Tabs */}
            <div className="border-b border-gray-200">
                <nav className="-mb-px flex space-x-8">
                    {[
                        { id: 'workflowTasks', label: 'Workflows', count: workflows?.length },
                        { id: 'tasks', label: 'Tasks', count: allTasksWorkflow.length },
                        { id: 'templates', label: 'Workflows Templates', count: workflowTemplates.length },

                        { id: 'difference', label: 'Workflow vs Task', count: 0 }
                    ].map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`py-2 px-1 border-b-2 font-medium text-sm ${activeTab === tab.id
                                ? 'border-blue-500 text-blue-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            {tab.label}
                            {tab.count > 0 && (
                                <span className="ml-2 bg-gray-100 text-gray-900 py-0.5 px-2 rounded-full text-xs">
                                    {tab.count}
                                </span>
                            )}
                        </button>
                    ))}
                </nav>
            </div>
        </div>
    );
};